import * as api from '../api';

//Action Creators
export const getGroups= () => async(dispatch) => {
    try{
        const {data} = await api.fetchGroups();
        dispatch({type: 'ALL_GROUPS', payload: data});
    } catch(error){
        // Handle error silently
    }    
};

export const getSearchedTransactions= (searchQuery) => async(dispatch) =>{
    try{        
        const { data: {data} } = await api.fetchSearchedInsiderTrans(searchQuery);
        dispatch({type: 'SEARCH_GROUPS', payload: data});
    }catch(error){
        // Handle error silently
    }
};

